import { getCookie } from "./cookies"

export function logEvent(name, options) {
  if (typeof window.amplitude === "undefined") return

  window.amplitude.getInstance().logEvent(name, {
    ...options,
    browserId: getCookie("browser_id"),
  })
}

export function logUploadFlowEvent(name, options) {
  const prefix = "upload_flow_"
  const updatedName = `${prefix}${name}`
  const updatedOptions = {
    ...options,
    source: "redesigned_upload",
  }

  logEvent(updatedName, updatedOptions)
}
